<template>
   <div class="orderlist">
    <van-action-sheet v-model:show="store.dislog.order" title="请选择需要咨询的内容" @closed="close">
      <van-tabs v-model:active="actOrderType" shrink  :before-change="tabClick"  v-if="getNavs.length>0">
        <van-tab v-for="i in getNavs" :title="i.label"  :name="i.value">
           <div class="qTabs"   v-if="getQueryString('goods_id') && actOrderType=='10'"  >
            <span class="query" :class="{'act':!goodsId}"  @click="rest(null)">全部</span>
            <span class="query" :class="{'act':goodsId}" @click="rest(getQueryString('goods_id'))">当前商品</span>
          </div> 
        </van-tab>
      </van-tabs>
      <div class="content">
        <div class="scroll" @scroll="onScroll">
           <div class="nobg" v-if="comments.length==0 && finished">
            <div class="thtit">暂无订单</div>
          </div>
          <div class="li" v-for="i in comments">
            <div class="tp">
              <span class="no">订单号：{{ i.order_no }}</span>
              <span class="time">{{ fTime(i.create_time)}}</span>
            </div>
            <div class="mains" v-for="(j,index) in i.goods">
              <img :src="j.image_url" />
              <div class="rt">
                <div class="name">{{j.goods_name}}</div>
                <div class="nums">x{{j.total_num}}</div>
                <div class="bot">
                  <div class="lf"></div>
                  <div class="nsend" @click="send(i,j)" v-if="index==i.goods.length-1 || actOrderType=='10'">发送</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
   </div>
</template>
<script setup>
  import {ref,computed} from 'vue'
	import { useSocket } from "@/stores/index";
  import  { useWork } from '@/stores/work'
  import {getOrderList} from '@/api/index';
  import { getQueryString } from '@/assets/js/index';
  import { sendType } from '@/assets/js/index';
  const goodsId=ref(getQueryString('goods_id') || '')
 
  const store=useSocket()
  const comments=ref([])
  const actOrderType=ref(getQueryString('type') || '10')
  const pages=ref(1)
  const finished=ref(false)
  const loading=ref(false)
  const getNavs=computed(()=>{
    const isSuper=store.group.supplierId==0   //1是平台
    if(isSuper){
        return store.orderType
    }else{
        return store.orderType.filter(item=>item.value*1==10)
    }
  })
  
  const tabClick=(item)=>{
    comments.value=[]
    actOrderType.value=item+''
    pages.value=1
    finished.value=false
    init()
  }
  const onScroll=(e)=>{
    const { scrollTop, scrollHeight, clientHeight } = e.target
    // 当滚动到底部时加载更多（预留 50px 缓冲）
    if(finished.value){
      return
    }
    if (scrollHeight - scrollTop - clientHeight < 10 && !loading.value) {
      pages.value=pages.value+1
      init()
    }
  }
  const rest=(value)=>{
    comments.value=[]
    goodsId.value=value
    pages.value=1
    init()
  }

  const close=()=>{
    pages.value=1
    comments.value=[]
    finished.value=false
    store.seeOP('order',false)
  }
  const init=async(type)=>{
    const supplierCode=getQueryString('code') || store.group.supplierCode
    try{
      const data = {
      wxappId:useWork().auth.wxappId,
      order_type:actOrderType.value,
      supplierCode:supplierCode.toUpperCase(),
      orderNo:getQueryString('order_no'),
      goodsId:goodsId.value,
      page:pages.value,
    }
    for(let val in data){
      if(!data[val]){
        delete data[val]
      }
    }
    loading.value = true;
    const list = await getOrderList(data)
    if(list.length<10){
      finished.value=true
    }
    comments.value=[...comments.value,...list]
    loading.value = false;
    }catch(e){
      console.log(e)
    }
  }
  const fTime=(time)=>{
    if(time){
      let date=new Date(time);
      let year=date.getFullYear(),
          month=date.getMonth()+1,
          day=date.getDate();
      return year+'-'+month+'-'+day
    }else{
      return  '/'
    }
  }
  const send=(data,item)=>{
    // <div class='ordli'><img src='{imagePath}' /><div class='mains'><div class='tit' >{orderNo}</div><div class='say' >{skuName}</div></div></div>
    const content={
      imagePath:item.image_url,
      orderNo:data.order_no,
      skuName:item.goods_name,
      skuAttr:item.goods_attr,
      type:data.order_type,
      id:data.order_id
    }
    store.sendMess({
      content:JSON.stringify(content),
      groupId: store.group.id,
      type: sendType.ORDER
    })
    store.seeOP('order',false)
  }
  defineExpose({
    init
  });
</script>
<style lang="scss" scoped>
 .nobg{
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .thtit{
      background: url('@/assets/images/nobg.png') no-repeat center top;
      background-size: 81px auto;
      font-weight: 400;
      font-size: 15px;
      color: #333;
      text-align: center;
      padding-top:86px;
    }
}
.orderlist{
  ::v-deep{
    .van-tabs{
      margin-bottom: 10px;
    }
    .van-tabs__nav{
      background: none;
    }
    .query{
      display: inline-block;
      padding:0 10px;                                           
      line-height: 24px;
      border:1px solid #333;
      font-size: 12px;
      margin-right:10px;
      border-radius:4px;
      position: relative;
    }
    .qTabs{
      padding:10px 20px 0;
    }
    .act{
      border-color:#2196f3;
      background: #2196f3;
      color:#fff;
      border:0 none;
    }
  }
  .content{
    height: 400px;
    overflow: hidden;
    margin: 0;
    .scroll{
      overflow-y:auto;
      height: 100%;
      padding:0 10px;
    }
    .li{
      // height: 108px;
      background: #FFF;
      border-radius: 10px;
      box-sizing: border-box;
      padding: 10px 12px;
      margin-bottom: 12px;
      .tp{
        display: flex;
        font-weight: 400;
        font-size: 12px;
        color: #9A9A9A;
        height: 17px;
        align-items: center;
        justify-content: space-between;
      }
      .mains{
        display: flex;
        margin-top: 8px;
        justify-content: space-between;
        box-sizing: border-box;
 
        img{
          width: 58px;
          height: 58px;
          border-radius: 4px;
        }
        .rt{
          padding-left: 7px;
          width:calc(100% - 58px);
          box-sizing: border-box;
          flex:3;
          .name{
            font-size: 14px;
            color: #222;
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
          }
          .nums{
            font-weight: 400;
            font-size: 13px;
            color: #A2A2A2;
            line-height: 18px;
          }
          .bot{
            display: flex;
            justify-content: space-between;
             height: 24px;
             align-items: flex-end;
             .lf{
              .price{
                font-size: 15px;
                color: #EF413C;
                line-height: 21px;
              }
              .status{
                font-weight: 400;
                font-size: 13px;
                color: #A2A2A2;
                line-height: 18px;
                margin-left:7px;
              }
             }
            .nsend{
              width: 50px;
              line-height: 24px;
              background: #FF7D38;
              border-radius: 12px;
              text-align: center;
              font-weight: 400;
              font-size: 13px;
              color: #FFF;
            }
          }
        }
      }
    }
  }
  .pages{
    display: flex;
    justify-content: space-between;
    a{
      font-size: 14px;
      color: #333;
      text-decoration: none;
      padding: 10px 20px;
      border-radius: 4px;
      background: #F5F5F5;
    }
  }

}
</style>